<template>
  <div class="wrapper">
    <div class="">
      <slide-travail></slide-travail>
    </div>
    <div class="section">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item  md-xsmall-size-100 mx-auto text-center">
            <h2 class="title text-center">
              {{ $t("assurance.titre") }}
            </h2>
            <h5 class="description">
              {{ $t("assurance.sous-titre") }}
            </h5>
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <avantages></avantages>
    </div>
  </div>
</template>

<script>

import slideTravail from "@/views/myComponents/assurance/slideTravail";
import avantages from "@/views/myComponents/assurance/avantages";
export default {
  bodyClass: "etude",
  components: {
    slideTravail,
    avantages
  },
  props: {
    pays2: {
      type: String,
      default: require("@/assets/img/france.jpeg")
    },
    pays3: {
      type: String,
      default: require("@/assets/img/usa.jpeg")
    },
    pays4: {
      type: String,
      default: require("@/assets/img/turkie.jpeg")
    }
  },
  data() {
    return {};
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.hooper {
  height: auto;
}
</style>
